<p-sidebar
    [blockScroll]="true"
    [(visible)]="isVisible"
    [ariaCloseLabel]="'drawers.closeButton.ariaLabel' | translate"
    (onHide)="close()"
    position="right"
    id="sort-and-filter-drawer"
    class="custom-drawer">
    <ng-template pTemplate="header">
        {{ 'tableSettings' | translate }}:&nbsp;<span class="fw-400">{{ 'tableSettings.subtitle' | translate }}</span>
    </ng-template>

    <ng-template pTemplate="content">
        <div id="sort-and-filter-reset-container">
            @switch (selectedTab) {
                @case (tabs.FILTER) {
                    <div class="reset-filters-container">
                        <p id="reset-filters-text">{{ 'tableSettings.resetFiltersInfo' | translate }}</p>
                        <button
                            id="reset-filters-btn"
                            [label]="'tableSettings.clearFilters' | translate"
                            pButton
                            class="p-button-outlined p-button-sm reset-btn"
                            icon="fa-regular fa-filter-slash"
                            iconPos="left"
                            [disabled]="isFilterRestoreDisabled"
                            (click)="resetFiltersButtonClick()"></button>
                    </div>
                }

                @case (tabs.SORT) {
                    <div class="reset-filters-container">
                        <p id="reset-sort-text">{{ 'tableSettings.resetSortInfo' | translate }}</p>
                        <button
                            id="reset-sort-btn"
                            [label]="'tableSettings.clearSort' | translate"
                            pButton
                            class="p-button-outlined p-button-sm reset-btn"
                            icon="fa-regular fa-sliders"
                            iconPos="left"
                            [disabled]="isSortRestoreDisabled"
                            (click)="resetSortButtonClick()"></button>
                    </div>
                }
            }
        </div>

        <div id="tabs-container">
            <p-tabView class="tab-view" [activeIndex]="selectedTab" (onChange)="changeTab($event)">
                <p-tabPanel [header]="'tableSettings.filter' | translate" leftIcon="fa-light fa-filter" id="filter-tab">
                    <ng-content select="[filterContent]"></ng-content>
                </p-tabPanel>
                <p-tabPanel [header]="'tableSettings.sort' | translate" leftIcon="fa-light fa-sliders" id="sort-tab">
                    <app-sort-table [columns]="sortableColumns" (sortChanged)="changeSort($event)"></app-sort-table>
                </p-tabPanel>
            </p-tabView>
        </div>
    </ng-template>
</p-sidebar>
